// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/style.css
// module id = 661
// module chunks = 14